import { PatientDoctorId } from '@app/icare/entities/patient/schema/PatientDoctor'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientDoctorOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_doctor/-components/PatientDoctorOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_doctor/praxen/$relation')({
  params: entityParams({ id: PatientId, relation: PatientDoctorId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientDoctorOverview patientId={id} relationId={relation} />
}
